<div class="row">
    <div class="col-12 col-md-2 col-lg-2">
        <rask-button color="secondary" (click)="previousYear()"><i class="far fa-arrow-left"></i></rask-button>
    </div>
    <h3 class="col-12 col-md-8 col-lg-8 text-center">{{ getDisplayedFilter() }}</h3>
    <div class="col-12 col-md-2 col-lg-2 text-end">
        <rask-button  color="secondary" (click)="nextYear()"><i class="far fa-arrow-right"></i></rask-button>
    </div>
</div>
<div class="row">
    <rask-radiobutton-group [buttons]="views" [ngModel]="selectedView" (change)="changeView($event)"> </rask-radiobutton-group>
</div>